import { createSlice } from '@reduxjs/toolkit';

const notificationFetchInitialState = {
  isFetch: false,
};

export const notificationFetchSlice = createSlice({
  name: 'notificationFetch',
  initialState: notificationFetchInitialState,
  reducers: {
    changeFetching: (state) => {
      state.isFetch = true;
    },
    resetFetch: (state) => {
      state.isFetch = false;
    },
  },
});

export const { changeFetching, resetFetch } = notificationFetchSlice.actions;

export default notificationFetchSlice.reducer;
